/**
 * Returns auth headers including X-Tenant-Id for multi-tenant support.
 * Use this instead of manually building headers in pages.
 */
export function authHeaders(extra = {}) {
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('selectedTenantId');
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (tenantId) headers['X-Tenant-Id'] = tenantId;
  return { ...headers, ...extra };
}
